import React from 'react';
import { ListViewMedium } from '@blueprint/icons';
import { StyledRightButtonWithIcon } from './MobileQuickMenu.styles';
import { trackListViewClick } from './MobileQuickMenu.tracking';
import { useRouter } from 'next/router';
import { removePageSpecificParams } from 'search/helpers/removePageSpecificParams';

const listViewText = 'List view';

const ListViewButton: React.FC = () => {
    const { asPath } = useRouter();

    const href = asPath.replace('/map/', '/');
    const listViewPath = removePageSpecificParams(href);

    return (
        <StyledRightButtonWithIcon
            variant="secondary"
            isFullWidth
            href={listViewPath}
            onClick={trackListViewClick}
            data-testid="list-view"
        >
            <ListViewMedium />
            {listViewText}
        </StyledRightButtonWithIcon>
    );
};

export default ListViewButton;
